import { useModuleBEM } from "@b2bportal/core-themes";
import { Loading } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useReviewBalanceDisplay } from "./hooks";
import styles from "./styles.module.scss";

interface ReviewDetailsButtonProps {
  onContinue: () => void;
  continueButtonDisabled: boolean;
}

export const ReviewDetailsButton: React.FC<ReviewDetailsButtonProps> = ({
  onContinue,
  continueButtonDisabled,
}) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "ReviewDetailsButton");

  const { balanceToPay, isValidBalance, isConversionLoading } =
    useReviewBalanceDisplay();

  return (
    <button
      className={cn("continue_button")}
      onClick={onContinue}
      disabled={continueButtonDisabled || !isValidBalance}
    >
      <span className={cn("continue_button_content")}>
        {t(continueButtonDisabled ? "amountDue" : "reviewDetails")}
        {isConversionLoading ? (
          <Loading className={cn("loading")} />
        ) : (
          balanceToPay
        )}
      </span>
    </button>
  );
};
